export function toggleOverlay(isActive,data=null,type=null){
  return {
    type:'TOGGLE_OVERLAY',
    payload:{
      isActive:isActive,
      data:data,
      type:type
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/overlayAction.js